export default __webpack_public_path__ + "static/media/gallery_07.1f6ede16.jpg";